module.exports = __webpack_public_path__ + "img/prsf_text.2616a99c.png";